import { createStore } from 'satcheljs';
var defaultFolderForestStore = {
    selectedNode: {
        id: null,
        treeType: 'primaryFolderTree',
        type: 0 /* Folder */,
    },
};
export var getStore = createStore('folderForestStore', defaultFolderForestStore);
var folderForestStore = getStore();
export default folderForestStore;
//# sourceMappingURL=store.js.map